import React, { useContext, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import AppContext from './AppContext';
import { CircularProgress, Box } from '@mui/material';

const PrivateRoute = ({ component: Component, allowedRoles, ...rest }) => {
  const { userRole, isInitialized } = useContext(AppContext);
  
  const isAuthenticated = () => {
    return localStorage.getItem('authToken') !== null;
  };
  
  const hasAccess = () => {
    return isAuthenticated() && (allowedRoles ? allowedRoles.includes(userRole) : true);
  };

  const LoadingSpinner = () => (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
    >
      <CircularProgress />
    </Box>
  );

  // If the context is still initializing, show a loading state or return null
  if (!isInitialized) {
    return <LoadingSpinner />;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        hasAccess() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: isAuthenticated() ? '/unauthorized' : '/login',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;